import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Dialog, Button} from 'components/core';
import {List, ListItem, Breadcrumbs, Link, Typography, ListItemText, ListItemAvatar, Avatar} from '@material-ui/core';
import {NavigateNext} from '@material-ui/icons';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 240
    },
    item: {
        padding: '10px 56px',
        height: 60,
    },
    dialogContent:
    {
        padding: 0,
        height: '30vh'
    },
    breadcrumbs: {
        height: 24
    },
    avatar: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.main
    }
  }), {name: "NavigableSelectorPopup"});

// interface NavigableSelectorItem {
//     id: number,
//     name: string,
//     pictureSrc: string | null,
//     icon: Component | null,
//     navigable: boolean
// }

const testItems = [
    {
        id: 1,
        name: "Carpeta 1",
        navigable: true,
        icon: <NavigateNext />,
        children: [
            {
                id: 4,
                name: "Item 1"
            },
            {
                id: 5,
                name: "Item 2"
            },
            {
                id: 100,
                name: "Carpeta interna",
                navigable: true                
            }
        ]
    },
    {
        id: 2,
        name: "Carpeta 2",
        navigable: true,
    },
    {
        id: 3,
        name: "Carpeta 3",
        navigable: true,
    },
    {
        id: 6,
        name: "Item 3",
        icon: <NavigateNext />,
        picture: "http://localhost:3000/dev/api/operations/51/files/225/download"
    },
    {
        id: 7,
        name: "Item 4"
    },
];


function NavigableSelectorDialog({items, open = false, onClose = null, onConfirm = null, emptyText = "Sin contenido", ...props})
{
    const classes = useStyles();
    const [navigation, setNavigation] = React.useState([]);
    const [currentItems, setCurrentItems] = React.useState([]);

    React.useEffect(function initializeItems(){
        if(navigation.length === 0) setCurrentItems(items);
        else
        {
            let navItem = items[navigation[0]];
            for(let i = 1; i< navigation.length; i++)
            {
                navItem = navItem.children[navigation[i]];
            }
            if(!navItem.children) setCurrentItems([]);
            else setCurrentItems(navItem.children);
        }
    }, [navigation, items, open]);


    const handleClose = () => {
        setCurrentItems([]);
        setNavigation([]);
        if(onClose) onClose();
    };

    const handleItemClick = (index) => {
        if(currentItems[index].navigable)
        {
            let tmpNav = [...navigation, index];
            setNavigation(tmpNav);
        }
        else
        {
            if(onConfirm) onConfirm(currentItems[index]);
            handleClose();
        }
    }

    const handleNav = (index) => {
        if(index === -1) setNavigation([]);
        else {
            let tmpNav = [...navigation];
            tmpNav.splice(index+1, tmpNav.length);
            setNavigation(tmpNav);
        }
    }

    // generate names array for breadcrumbs
    let navNames = [];
    if(navigation.length > 0)
    {
        let navItem = items[navigation[0]];
        navNames.push(navItem.name);
        for(let i = 1; i< navigation.length; i++)
        {
            navItem = navItem.children[navigation[i]];
            navNames.push(navItem.name);
        }
    }


    const breadcrumbs = <Breadcrumbs className={classes.breadcrumbs} separator={<NavigateNext fontSize="small" />} aria-label="breadcrumb">
        {navigation.length > 0 && <Link color="inherit" onClick={() => handleNav(-1)} component="button">{"Todo"}</Link> }
            {navigation.map((itemIndex, navIndex) => <Link key={itemIndex} color="inherit" onClick={() => handleNav(navIndex)} component="button">{navNames[navIndex]}</Link>)}
    </Breadcrumbs>

    
    if(false && !open) return null;
    else return <Dialog title="Seleccione un punto AR" subtitle={breadcrumbs} open={open} contentClass={classes.dialogContent} onClose={handleClose} {...props}>
        <List className={classes.root}>
            {currentItems.map((item, index) => <NavigableSelectorItem key={item.id} item={item} onClick={() => handleItemClick(index)} /> )}
            {currentItems.length === 0 && <Typography className={classes.item}>{emptyText}</Typography>}
            {/* {navigation.length > 0 && <NavigableSelectorItem key={"back"} item={{name: "Atrás"}} onClick={() => handleNav(-1)} />} */}
        </List>
    </Dialog>
}

function NavigableSelectorItem({item, onClick})
{
    const classes = useStyles();

    return <ListItem button className={classes.item} onClick={onClick}>
        
        {item.picture ? 
        <ListItemAvatar>
            <Avatar className={classes.avatar} src={typeof(item.picture === 'string') && item.picture} variant='square'>{React.isValidElement(item.picture) && item.picture}</Avatar>
        </ListItemAvatar>
        :
        item.icon && 
        <ListItemAvatar>
              <Avatar className={classes.avatar}>
                {item.icon}
              </Avatar>
        </ListItemAvatar> 
        }
        
        <ListItemText>{item.name}</ListItemText>
    </ListItem>;
}

export {NavigableSelectorDialog}